import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class HttpInterceptorService implements HttpInterceptor {
    private personId: string;

    constructor() {

    }

    /*     intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
            this.personId = localStorage.getItem('administratorId');
            console.log('Setting personId in header: ' + this.personId)
    
            // uncomment the line 18-28 if you want test on the local server
            if (this.personId) {
                const modReq = req.clone({
                    headers: req.headers.set('Access-Control-Allow-Headers', '*')
                        .set('Access-Control-Allow-Credentials', 'true')
                        .set('Access-Control-Allow-Methods', 'GET,HEAD,OPTIONS,POST,PUT')
                        .set('Access-Control-Allow-Headers', 'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers')
                        .set('personid', this.personId)
                });
            }
            return next.handle(req);
        } */

    // uncomment the line 31-42 if you want on remote server
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.personId = localStorage.getItem('administratorId');
        if (this.personId) {
            const modReq = req.clone({
                setHeaders: {
                    personid: this.personId
                }
            });
            return next.handle(modReq);
        }
        return next.handle(req);
    }
}